import { render, staticRenderFns } from "./JiNanEmergency.vue?vue&type=template&id=339ab8d9&scoped=true"
import script from "./JiNanEmergency.vue?vue&type=script&lang=js"
export * from "./JiNanEmergency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339ab8d9",
  null
  
)

export default component.exports